var _defs, _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12524023391582967227(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d3e50;}.cls-2{fill:#2e79bd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.7548,17.32973H8.89077a7.68048,7.68048,0,0,0-7.6717,7.67179v79.95869a7.6805,7.6805,0,0,0,7.6717,7.67188h25.864a7.68054,7.68054,0,0,0,7.67188-7.67188V25.00152A7.68052,7.68052,0,0,0,34.7548,17.32973Zm0,88.91833H8.89077a1.28919,1.28919,0,0,1-1.28767-1.28785V25.00152a1.28917,1.28917,0,0,1,1.28767-1.28776h25.864a1.28921,1.28921,0,0,1,1.28785,1.28776v9.47072A93.82966,93.82966,0,0,0,18.48441,36.8414a2.8995,2.8995,0,0,0-2.20324,2.818V42.316a89.27555,89.27555,0,0,0,19.76148,2.95169v6.8363A93.82966,93.82966,0,0,0,18.48441,54.4731a2.8995,2.8995,0,0,0-2.20324,2.818v2.65658a89.27555,89.27555,0,0,0,19.76148,2.95169v42.06087A1.28922,1.28922,0,0,1,34.7548,106.24806Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.19835,
    y: 81.27589,
    width: 15.24899,
    height: 3.28321
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.19835,
    y: 88.90041,
    width: 15.24899,
    height: 3.28321
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.9121,
    y: 93.90864,
    width: 15.24899,
    height: 3.28321
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.82063,17.32973h-18.568a7.68048,7.68048,0,0,0-7.6717,7.67179v79.95869a7.6805,7.6805,0,0,0,7.6717,7.67188h18.568a7.6805,7.6805,0,0,0,7.6717-7.67188V25.00152A7.68048,7.68048,0,0,0,72.82063,17.32973Zm1.28767,87.63048a1.28919,1.28919,0,0,1-1.28767,1.28785h-18.568a1.28919,1.28919,0,0,1-1.28767-1.28785V25.00152a1.28917,1.28917,0,0,1,1.28767-1.28776h18.568a1.28917,1.28917,0,0,1,1.28767,1.28776Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.53654,87.11272a2.55351,2.55351,0,0,0,2.55361-2.55361V43.45267a2.55361,2.55361,0,1,0-5.10722,0V84.55911A2.55351,2.55351,0,0,0,63.53654,87.11272Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.75052,102.00546l-7.08068-79.64474a7.68,7.68,0,0,0-8.32114-6.96222l-18.495,1.64428a7.68059,7.68059,0,0,0-6.9624,8.321L92.972,105.00848a7.67335,7.67335,0,0,0,7.62841,6.993q.34494,0,.69273-.03082l18.495-1.64428A7.68086,7.68086,0,0,0,126.75052,102.00546Zm-7.52777,1.96188-18.495,1.64428a1.28739,1.28739,0,0,1-1.39668-1.1685L92.25041,24.79836a1.28917,1.28917,0,0,1,1.16868-1.39668l18.495-1.64428a1.2878,1.2878,0,0,1,1.39668,1.16868l7.08068,79.64457A1.28911,1.28911,0,0,1,119.22275,103.96733Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.05177,85.73973c.07553,0,.15212-.00338.22907-.01015a2.55372,2.55372,0,0,0,2.31742-2.76986l-3.64018-40.94488a2.55367,2.55367,0,0,0-5.08727.45226L105.511,83.412A2.55382,2.55382,0,0,0,108.05177,85.73973Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 109.02793,
    cy: 94.13385,
    r: 3.87386,
    transform: "translate(-7.90753 10.02458) rotate(-5.08038)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12524023391582967227);
export default __webpack_public_path__ + "static/media/12524023391582967227.ba7e9dde.svg";
export { ForwardRef as ReactComponent };